export default {
  compareYears: 'Comparar anos',
  granularity: 'Granularidade',
  monthly: 'Mensal',
  quarterly: 'Trimestral',
  weekly: 'Semanal'
}
